



























































































import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {FamocoDevice, TerminalConfigNext} from "../../modules/models";
import Api from "./Api";
import Routes from "../../modules/Routes";
import rd from "../../modules/vRoutedefs";
import UserRequired from "../UserRequired";
import SuperSheet from "@/components/shared/SuperSheet.vue";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-super": SuperSheet,
    }
})
export default class PendingTerminalPage extends UserRequired {
    @Inject()
    api!: Api;

    @Prop()
    guid!: string;

    terminalConfig: TerminalConfigNext | null = null;
    famoco: FamocoDevice | null = null;

    get locationUrl() {
        if(this.terminalConfig != null && this.terminalConfig.location != null) {
            return Routes.pages.location(this.terminalConfig.location.companyOrgNum, this.terminalConfig.location.id);
        }
        return null;
    }

    showDeleteConfirm = false;
    confirmDeleteConfig() {
        this.showDeleteConfirm = true;
    }
    closeDeleteConfirm() {
        this.showDeleteConfirm = false;
    }

    async deleteConfig() {
        if(this.terminalConfig) {
            await this.api.deletePendingconfig(this.terminalConfig.guid);
            this.$emit("at-snackmsg", `Terminalkonfigurasjon ${this.terminalConfig.description} fjernet`);
            await ignoreRedundantNavErr(this.$router.replace({name: rd.terminals.name}))
        }
    }

    @Watch("guid", {immediate: true})
    async onGuidChanged() {
        this.terminalConfig = await this.api.fetchTerminalConfigNext(this.guid);
        this.famoco = await this.api.getFamocoDeviceInfo(this.guid);
        if(this.famoco && this.famoco.shouldRefresh()) {
            // More than a minute since famoco info was last refreshed from api, refresh again.
            await this.api.refreshFamocoDeviceInfo(this.famoco.id);
            // Reload fresh info
            this.famoco = await this.api.getFamocoDeviceInfo(this.guid);
        }
    }

}
